import request from '@/CommonDP/utils/request';
export default {
  // 新增
  insertLinearList(params) {
    return request
      .post(`/linear/insertLinearList`, params)
      .then((res) => res);
  },
  // 修改
  updateLinearList(params) {
    return request
      .post(`/linear/updateLinearList`, params)
      .then((res) => res);
  },
  // 详情
  linearDetail(id) {
    return request.get(`/linear/getidlist?id=` + id).then((res) => res);
  },
  // 删除
  linearDelete(id) {
    return request
      .post(`/linear/deleteLinearList?id=` + id)
      .then((res) => res);
  },
  // 列表
  getLinearList(enterpriseId) {
    return request
      .get(`/linear/getLinearList?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  }
};
